//兼容处理
// let max = 1.5;
let min = 0.75;
function setHtml() {
  //获取设备宽度
  var deviceWidth = document.documentElement.offsetWidth;
  // let deviceHeight = document.documentElement.offsetHeight * 2;

  // let deviceSzie = Math.max(deviceHeight, deviceWidth)
  //给html标签设置fontSize，就是给rem赋值
  // 设置缩放范围
  // let scale = deviceSzie / 1710;
  let scale = deviceWidth / 1710;
  // let baseFont = scale > max ? max : (scale < min ? min : scale);
  let baseFont = (scale < min ? min : scale);
  document.documentElement.style.fontSize = Math.floor(baseFont * 16) + 'px';
}

//窗口大小变化的时候执行
// window.onresize = setHtml;
window.addEventListener('resize', setHtml)
//页面初始加载时也要触发
setHtml();
